/**
 * Stable `MedicationPreferenceConfig.id` values for payment survey medication preference.
 * Selection is `getResolvedMedicationPreferenceId` in `src/utils/userSegment/features.ts`;
 * `medicationPreference.tsx` maps each id to a config object.
 */
export const MEDICATION_PREFERENCE_ID = {
  BRANDED_WEGOVY_PILL_OR_COMPOUNDED_MICRODOSE:
    "BRANDED_WEGOVY_PILL_OR_COMPOUNDED_MICRODOSE",
  COMPOUNDED_OR_BRANDED: "COMPOUNDED_OR_BRANDED",
  COMPOUNDED_OR_COMPOUNDED_MICRODOSE: "COMPOUNDED_OR_COMPOUNDED_MICRODOSE",
  COMPOUNDED_TIRZEPATIDE_OR_COMPOUNDED_MICRODOSE:
    "COMPOUNDED_TIRZEPATIDE_OR_COMPOUNDED_MICRODOSE",
  COMPOUNDED_TIRZEPATIDE_OR_BRANDED_ZEPBOUND_VIAL:
    "COMPOUNDED_TIRZEPATIDE_OR_BRANDED_ZEPBOUND_VIAL",
  COMPOUNDED_TIRZEPATIDE_OR_COMPOUNDED: "COMPOUNDED_TIRZEPATIDE_OR_COMPOUNDED",
} as const;

export type MedicationPreferenceId =
  (typeof MEDICATION_PREFERENCE_ID)[keyof typeof MEDICATION_PREFERENCE_ID];
